import axiosWrapper from './axiosWrapper'

const URL_PRESTADOR = `api/prov`
const URL_LISTA_PROV = `api/listaprovs`
const URL_PRESTADOR_PORTAL = `api/v1/portal/prestador`

const get = (axiosParams, uidUser) => {
  const url = `${axiosParams.baseURL}/${URL_PRESTADOR}/${uidUser}`
  return axiosWrapper.get({ ...axiosParams, url })
}

const getPrestadores = (axiosParams) => {
  const url = `${axiosParams.baseURL}/${URL_LISTA_PROV}`
  return axiosWrapper.get({ ...axiosParams, url })
}

const getSucursales = (axiosParams, uidPrestador) => {
  const url = `${axiosParams.baseURL}/${URL_PRESTADOR}/${uidPrestador}/suc`
  return axiosWrapper.get({ ...axiosParams, url })
}

const guardarPrestador = (axiosParams, uidPrestador, prestador) => {
  const url = `${axiosParams.baseURL}/${URL_PRESTADOR_PORTAL}/${uidPrestador}`
  return axiosWrapper.put({ ...axiosParams, url }, prestador)
}

const agregarObservacion = (axiosParams, uidPrestador, data) => {
  const url = `${axiosParams.baseURL}/${URL_PRESTADOR}/${uidPrestador}/addComentarioPerfil`
  return axiosWrapper.post({ ...axiosParams, url }, data)
}

const uploadFile = (axiosParams, uidPrestador, data) => {
  const url = `${axiosParams.baseURL}/${URL_PRESTADOR_PORTAL}/${uidPrestador}/upload`
  return axiosWrapper.post({ ...axiosParams, url }, data)
}

const servicePrestador = {
  get,
  getPrestadores,
  getSucursales,
  guardarPrestador,
  agregarObservacion,
  uploadFile
}

export default servicePrestador
